import { Route, Routes } from 'react-router';

import InvoicesDetail from './InvoicesDetail';
import InvoicesOverview from './InvoicesOverview';

export default function InvoicesRoutes() {
  return (
    <Routes>
      <Route index element={<InvoicesOverview />} />
      <Route path="/:id" element={<InvoicesDetail />} />
    </Routes>
  );
}
